import EndpointsBase from "../EndpointsBase";
import { ISingleSortBoxItemModel } from "../SortBoxItem/ISortBoxItemModel";

class SinglesEndpoints extends EndpointsBase {
  loadSingleItems(cartNumber: number) {
    return this._sendRequest<ISingleSortBoxItemModel[]>({
      method: "single/items",
      headers: this._getAuthHeader(),
      data: { cartNumber },
      run: this.server.getData,
    });
  }
}

export default new SinglesEndpoints();
